import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@common/common.module';
import { ViewMode } from '@common/models/view-mode';
import { ChangePasswordModalComponent } from './components/change-password-modal/change-password-modal.component';
import { UserAccountViewComponent } from './components/user-account-view/user-account-view.component';

export const USER_PROFILE_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'view',
        pathMatch: 'full'
    },
    {
        path: 'edit/:id',
        component: UserAccountViewComponent,
        data: {
            mode: ViewMode.edit
        }
    },
    {
        path: 'view/:id',
        component: UserAccountViewComponent,
        data: {
            mode: ViewMode.view
        }
    },
    {
        path: '**',
        redirectTo: 'view'
    }
];

@NgModule({
    declarations: [ChangePasswordModalComponent, UserAccountViewComponent],
    imports: [CommonModule, RouterModule.forChild(USER_PROFILE_ROUTES)]
})
export class UserAccountModule { }
